import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/ui/UIElements/Modal";
import { Icon } from "@/components/ui";

/**
 * WhatsAppDisconnectModal - Confirmation modal for disconnecting WhatsApp OAuth
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {Function} props.onConfirm - Callback when disconnect is confirmed
 * @param {boolean} props.isLoading - Whether disconnect action is in progress
 */
const WhatsAppDisconnectModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const { t } = useTranslation("aiAgents");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("whatsappOAuth.disconnectModal.title")}
      maxWidth="max-w-md"
    >
      <div className="space-y-4">
        {/* Warning Box */}
        <div className="rounded-lg border border-yellow-800 bg-yellow-900/20 p-4">
          <div className="flex items-start space-x-3">
            <Icon
              name="AlertTriangle"
              className="mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-500"
            />
            <p className="text-sm text-yellow-300">
              {t("whatsappOAuth.disconnectModal.message")}
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-lg border border-gray-600 px-4 py-2 text-sm font-medium text-gray-300 transition-colors hover:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {t("whatsappOAuth.disconnectModal.cancel")}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="inline-flex items-center justify-center rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? (
              <>
                <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                {t("whatsappOAuth.disconnectModal.confirm")}...
              </>
            ) : (
              <>
                <Icon name="Unlink" className="mr-2 h-4 w-4" />
                {t("whatsappOAuth.disconnectModal.confirm")}
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WhatsAppDisconnectModal;
